// constants
import { FormBuilderActionTypes } from './constants';

export interface FormBuilderActionType<TPayload> {
    type:
    | FormBuilderActionTypes.CHANGE_CHART_FUNNEL
    | FormBuilderActionTypes.CHANGE_CHART_GAUGE
    | FormBuilderActionTypes.CHANGE_CHART_SCATTER
    | FormBuilderActionTypes.CHANGE_ISSORTING
    | FormBuilderActionTypes.CHANGE_ISCONDITIONALLY
    | FormBuilderActionTypes.CHANGE_ISCHANGESHAXES
    | FormBuilderActionTypes.CHANGE_CHART_GRIDLINE
    | FormBuilderActionTypes.CHANGE_CHART_TOOLTIP
    | FormBuilderActionTypes.CHANGE_CHART_WIDGET
    | FormBuilderActionTypes.CHANGE_FORM_TABLENAME
    | FormBuilderActionTypes.CHANGE_ACTIVEKEY_PUBLICSETTINGS
    | FormBuilderActionTypes.CHANGE_CHART_LEGEND
    | FormBuilderActionTypes.CHANGE_CHART_PUBLIC
    | FormBuilderActionTypes.CHANGE_CHART_LABELONCHART
    | FormBuilderActionTypes.CHANGE_CHART_TABLESTYLE
    | FormBuilderActionTypes.CHANGE_MAPTYPE
    | FormBuilderActionTypes.CHANGE_GAUGETYPE
    | FormBuilderActionTypes.CHANGE_RESET_INITIAL_STATE
    | FormBuilderActionTypes.CHANGE_CHART_DRILL_STEP
    | FormBuilderActionTypes.CHANGE_CHART_DRILL
    | FormBuilderActionTypes.CHANGE_CHART_DATA
    | FormBuilderActionTypes.CHANGE_CHARTTYPE
    | FormBuilderActionTypes.CHANGE_CHARTCOLORPALLET
    | FormBuilderActionTypes.CHANGE_SEARCH_VALUE
    | FormBuilderActionTypes.CHANGE_FORMID
    | FormBuilderActionTypes.CHANGE_FIELD
    | FormBuilderActionTypes.CHANGE_BOAD
    | FormBuilderActionTypes.CHANGE_SHAXES
    | FormBuilderActionTypes.CHANGE_SHAXES_AGGREGATION
    | FormBuilderActionTypes.CHANGE_SHAXES_UNIQNAME
    | FormBuilderActionTypes.CHANGE_BOAD_SETTING
    | FormBuilderActionTypes.CHANGE_SHAXES_SORT
    | FormBuilderActionTypes.CHANGE_BOAD_FILTER
    | FormBuilderActionTypes.CHANGE_SHAXES_FILTER
    | FormBuilderActionTypes.CHANGE_CONDITION_FILTER
    | FormBuilderActionTypes.CHANGE_BOAD_FILTERCRITERIA
    | FormBuilderActionTypes.CHANGE_SHAXES_FILTERCRITERIA
    | FormBuilderActionTypes.CHANGE_CONDITION_FILTERCRITERIA
    | FormBuilderActionTypes.CHANGE_SHAXES_FILTERAGGREGATION
    | FormBuilderActionTypes.CHANGE_SHAXES_CALCULATETYPE
    | FormBuilderActionTypes.CHANGE_SHAXES_HEATMAPMODE
    | FormBuilderActionTypes.CHANGE_SHAXES_DESIGN
    | FormBuilderActionTypes.CHANGE_CONDOTION
    | FormBuilderActionTypes.CHANGE_GROUPES
    | FormBuilderActionTypes.CHANGE_TESTAM
    | FormBuilderActionTypes.CHANGE_SHAXES_CONDITIONALLITY
    | FormBuilderActionTypes.CHANGE_TABLE_CONDITIONALLITY
    | FormBuilderActionTypes.CHANGE_GET_CONDITIONALLITYLIST       
    | FormBuilderActionTypes.CHANGE_CONDITIONALLITY       
    payload?: TPayload;
}

export const changeFormDataAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_DATA,
    payload: layout,
});

export const changeFormSearchValueAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SEARCH_VALUE,
    payload: layout,
});

export const changeFormIdAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_FORMID,
    payload: layout,
});

export const changeFormFieldAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_FIELD,
    payload: layout,
});

export const changeFormBoadAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_BOAD,
    payload: layout,
});

export const changeFormShaxesAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES,
    payload: layout,
});

export const changeFormShaxesAggregationAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_AGGREGATION,
    payload: layout,
});

export const changeFormShaxesUniqNameAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_UNIQNAME,
    payload: layout,
});

export const changeFormIsSortingAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_ISSORTING,
    payload: layout,
});

export const changeFormIsConditionally = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_ISCONDITIONALLY,
    payload: layout,
});

export const changeFormIsChangeShaxesAction = (): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_ISCHANGESHAXES,
    //payload: layout,
});

export const changeFormBoadStttingAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_BOAD_SETTING,
    payload: layout,
});

export const changeFormShaxesConditionallityAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_CONDITIONALLITY,
    payload: layout,
});

export const changeFormTableConditionallityAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_TABLE_CONDITIONALLITY,
    payload: layout,
});

export const changeFormBoadFilterAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_BOAD_FILTER,
    payload: layout,
});

export const changeFormShaxesFilterAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_FILTER,
    payload: layout,
});

export const changeFormConditionFilterAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CONDITION_FILTER,
    payload: layout,
});

export const changeFormBoadFilterCriteriaAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_BOAD_FILTERCRITERIA,
    payload: layout,
});

export const changeFormShaxesFilterCriteriaAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_FILTERCRITERIA,
    payload: layout,
});

export const changeFormShaxesFilterAggregationAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_FILTERAGGREGATION,
    payload: layout,
});

export const changeFormConditionFilterCriteriaAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CONDITION_FILTERCRITERIA,
    payload: layout,
});

export const changeFormShaxesSortAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_SORT,
    payload: layout,
});

export const changeFormShaxesCalculateTypeAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_CALCULATETYPE,
    payload: layout,
});

export const changeFormShaxesHeatmapModeAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_HEATMAPMODE,
    payload: layout,
});

export const changeFormShaxesDesignAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_SHAXES_DESIGN,
    payload: layout,
});

export const changeFormConditionAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CONDOTION,
    payload: layout,
});

export const changeFormGroupesAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_GROUPES,
    payload: layout,
});

export const changeFormTypeAction = (chartType: any, isStack: any, isGroup: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHARTTYPE,
    payload: {chartType, isStack, isGroup},
});

export const changeFormColorPalletAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHARTCOLORPALLET,
    payload: layout,
});

export const changeFormMapTypeChartAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_MAPTYPE,
    payload: layout,
});

export const changeFormGaugeTypeChartAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_GAUGETYPE,
    payload: layout,
});

export const changeFormDrillAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_DRILL,
    payload: layout,
});

export const changeFormDrillStepAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_DRILL_STEP,
    payload: layout,
});


export const changeFormTestam = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_TESTAM,
    payload: layout,
});

export const resetFormToInitialStateAction = (): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_RESET_INITIAL_STATE,
    //payload: layout,
});

export const changeFormActiveKeyPublicSettingsAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_ACTIVEKEY_PUBLICSETTINGS,
    payload: layout,
});

export const changeFormLegendAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_LEGEND,
    payload: layout,
});

export const changeFormPublicAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_PUBLIC,
    payload: layout,
});

export const changeFormLabelOnChartAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_LABELONCHART,
    payload: layout,
});

export const changeFormTableStyleAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_TABLESTYLE,
    payload: layout,
});

export const changeFormTooltipAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_TOOLTIP,
    payload: layout,
});

export const changeFormWidgetAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_WIDGET,
    payload: layout,
});

export const changeFormTableNameAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_FORM_TABLENAME,
    payload: layout,
});

export const changeFormGaugeAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_GAUGE,
    payload: layout,
});

export const changeFormScatterAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_SCATTER,
    payload: layout,
});

export const changeFormGridLineAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_GRIDLINE,
    payload: layout,
});

export const changeFormFunnelAction = (layout: any): FormBuilderActionType<any> => ({
    type: FormBuilderActionTypes.CHANGE_CHART_FUNNEL,
    payload: layout,
});


